import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './styles.scss'
import App from './App.jsx'
import { DataProvider } from './store.jsx'

import { applyTheme } from './lib/theme.js'

applyTheme()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <DataProvider>
      <BrowserRouter><App /></BrowserRouter>
    </DataProvider>
  </React.StrictMode>,
)
